export const appTypo = {
  font: {
    kintoSans: "kinto-sans",
  },
} as const;
